import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import getMeetDistinctEvents from './GetMeetDistinctEvents';

const MeetDistinctEventsData = { INITIAL_STATE: { ...BASIC_INITIAL_STATE, arrayAsOptions: [] }, getMeetDistinctEvents };
export default MeetDistinctEventsData;